export default class NumberHelpers {
  /**
   * Formats a number to a fixed-point notation with the specified precision.
   *
   * @param num - The number to format.
   * @param precision - The number of digits to appear after the decimal point. Defaults to 2.
   * @returns The formatted number as a string.
   * @throws Will throw an error if the input is not a valid number.
   */
  public static toFixed = (
    num: number,
    precision = 2,
    significantDigit: number | undefined = undefined,
  ) => {
    const pow = 10 ** precision;
    const result = Math.round(num * pow) / pow;

    if (significantDigit !== undefined) return result.toFixed(significantDigit);

    return result;
  };

  public static parse = (num: number) => Number.parseInt(num.toString());

  public static priceFormatter = (num: number | undefined) => {
    if (num === undefined || num === 0) return "--,-- €";

    return `${NumberHelpers.toFixed(num ?? 1, 2, 2)} €`;
  };
}
